export const LAYOUT_CONTENT_CLASS = 'cf-app-content-layout-scroll-top'
export const LOCKED_CONTENT_BANNER_ID = 'locked-content-banner'
